import { ThemeService } from '../../services/theme.service';
import { ChangeDetectorRef, Component, computed, effect, inject, OnDestroy, OnInit, PLATFORM_ID, signal, untracked } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { DataService } from '../../services/data';
import { StorageService } from '../../services/storage-service';
import { Authen } from '../../layout/authen/authen';
import { CommonModule } from '@angular/common';

import { ActivatedRoute, Router } from '@angular/router';
import { AppUrl } from '../../appUrl';

import { DatePicker } from 'primeng/datepicker';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { ButtonModule } from 'primeng/button';
import { CheckinComponent } from '../checkin/checkin.component';
import { ThaidatePipe } from '../../pipe/thaidate-pipe';
import { SelectGuestRoomComponent } from '../select-guest-room/select-guest-room.component';
import moment from 'moment';
import { environment } from '../../../environments/environment';
import { DragScrollDirective } from '../../directives/drag-scroll.directive';
import { TranslateModule } from '../../shareds/translate/translate.module';
import { LanguageSwitcher } from '../../shareds/translate/language-switcher';
@Component({
  selector: 'app-list-room',
  imports: [Authen,
    CommonModule,
    FormsModule,
    InputTextModule,
    ButtonModule,
    CheckinComponent,
    ThaidatePipe,
    SelectGuestRoomComponent,
    DragScrollDirective,
    TranslateModule,
    LanguageSwitcher],
  templateUrl: './list-room.component.html',
  styleUrls: ['./list-room.component.scss']
})
export class ListRoomComponent implements OnInit, OnDestroy {
  private savedBranchId = signal<any>(null);
  private savedPlanQtyMap: Record<string, number> | null = null;
  private savedPlanPriceMap: Record<string, number> | null = null;
  private savedSnapshotAdults: number | null = null;
  private savedSnapshotChildren: number | null = null;
  private manualOpen = false;
  private beforeUnloadHandler = () => this.saveState();
  private scrollHandler = () => {
    const atTop = window.scrollY < 60;
    if (atTop) {
      // กลับขึ้นบนสุด → เปิดเสมอ และรีเซ็ต flag
      this.manualOpen = false;
      this.searchHeroExpanded.set(true);
    } else if (!this.manualOpen) {
      // เลื่อนลง และยังไม่ได้กดเปิดเอง → พับ
      this.searchHeroExpanded.set(false);
    }
  };

  toggleSearchHero() {
    const next = !this.searchHeroExpanded();
    this.manualOpen = next; // ถ้าผู้ใช้กดเปิด ให้ lock ไม่ให้ auto-พับ
    this.searchHeroExpanded.set(next);
  }
  imgURL = environment.imgURL;
  private platformId = inject(PLATFORM_ID);
  protected theme = inject(ThemeService);
  hasToken = () => !!this.st.getAccessToken();
  branchItems = signal<{ data: any[] } | null>(null);
  constructor(private data: DataService,
    private http: HttpClient,
    private router: Router,
    private ac: ActivatedRoute,
    private st: StorageService,
    private cdr: ChangeDetectorRef,
  ) {
    // เมื่อ branch โหลดเสร็จ: ดึง BranchDetail และ auto-search
    let prevBranchId: any = undefined;
    effect(() => {
      const branch = this.branchItem();
      if (!branch) return;
      untracked(() => {
        if (prevBranchId === undefined) {
          // โหลดครั้งแรก: restore planQtyMap เฉพาะเมื่อ branch ตรงกับที่บันทึกไว้
          if (this.savedPlanQtyMap && this.savedBranchId() !== null && String(this.savedBranchId()) === String(branch.id)) {
            this.planQtyMap.set(this.savedPlanQtyMap);
            if (this.savedPlanPriceMap) this.planPriceMap.set(this.savedPlanPriceMap);
            if (this.savedSnapshotAdults !== null) this.snapshotAdults.set(this.savedSnapshotAdults);
            if (this.savedSnapshotChildren !== null) this.snapshotChildren.set(this.savedSnapshotChildren);
          }
        } else if (String(prevBranchId) !== String(branch.id)) {
          // branch เปลี่ยน → clear
          this.planQtyMap.set({});
          this.planPriceMap.set({});
        }
        prevBranchId = branch.id;
        // ดึง BranchDetail พร้อม BranchId
        this.http.get<any>(`/api/Public/ReserveHotel/BranchDetail?BranchId=${branch.id}`).subscribe({
          next: (res) => {
            this.branchDetail.set(res?.data ?? null)
          },
          error: () => {
            console.log('XNS');
            
           }
        });
        // Auto-search ถ้ายังไม่เคย search
        if (!this.hasSearched()) this.search();
      });
    });
  }

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return; // ไม่ทำงานบน SSR server

    // set appId ก่อน HTTP call ทุกตัว
    const appId = this.ac.snapshot.params['app-id'];
    if (appId) this.st.setAppId(appId);

    // โหลด Branch (หลัง setAppId เพื่อให้ header www-app-id ถูกส่งไปด้วย)
    this.http.get<{ data: any[] }>('/api/Public/ReserveHotel/Branch').subscribe({
      next: (res) => this.branchItems.set(res),
      error: (err) => { if (err.status === 403 || err.status === 400) this.router.navigate(['/not-found']); }
    });

    if (this.st.ok) {
      window.addEventListener('scroll', this.scrollHandler, { passive: true });
      window.addEventListener('beforeunload', this.beforeUnloadHandler);
    }
    // Restore state เมื่อกลับจากหน้าถัดไป
    const saved = this.st.getSession('listRoomState');
    if (saved) {
      const s = JSON.parse(saved);
      this.checkIn.set(new Date(s.checkIn));
      this.checkOut.set(new Date(s.checkOut));
      this.totalAdultsAmount.set(s.totalAdultsAmount);
      this.totalChildrenAmount.set(s.totalChildrenAmount);
      this.totalGuestAmount.set(s.totalGuestAmount);
      this.totalRoomAmount.set(s.totalRoomAmount);
      this.savedBranchId.set(s.branchId ?? null);
      this.savedPlanQtyMap = s.planQtyMap ?? null;
      this.savedPlanPriceMap = s.planPriceMap ?? null;
      this.savedSnapshotAdults = s.snapshotAdults ?? null;
      this.savedSnapshotChildren = s.snapshotChildren ?? null;
    }
  }
  // loadingBranch = signal(false);

  // private reload = signal(0);                 // ✅ เป็น signal
  // private reload$ = toObservable(this.reload); // ✅ แปลงเป็น Observable

  // branchItems = toSignal(
  //   this.reload$.pipe(
  //     switchMap(() => {
  //       this.loadingBranch.set(true);
  //       return this.http.get<any>(`/api/Public/ReserveHotel/Branch`).pipe(
  //         finalize(() => this.loadingBranch.set(false)),
  //         catchError(() => of({ data: [] }))  // ✅ ต้องคืน “object” ไม่ใช่ array
  //       );
  //     })
  //   ),
  //   { initialValue: { data: [] } as any }

  // );
  branchDetail = signal<any>(null);

  branchItem = computed(() => {
    const items = this.branchItems()?.data ?? [];
    const urlBranchId = this.ac.snapshot.params['branch-id'];
    const fallbackId = this.savedBranchId();
    const branchId = urlBranchId ?? fallbackId;
    if (branchId) {
      return items.find((b: any) => String(b.id) === String(branchId)) ?? items[0] ?? null;
    }
    return items[0] ?? null;
  });
  branchDetailData = () => this.branchDetail();

  branchAddress = computed(() => {
    const d = this.branchDetailData();
    if (!d) return '';
    return [d.address, d.district, d.province].filter(Boolean).join(' ');
  });

  searchHeroExpanded = signal(true);
  branchExpandFacilities = signal(false);
  branchExpandDetail = signal(false);

  getBranchFacilities(): any[] {
    return this.branchDetailData()?.facilities ?? [];
  }

  getDisplayedBranchFacilities(): any[] {
    const all = this.getBranchFacilities();
    return this.branchExpandFacilities() ? all : all.slice(0, 6);
  }

  // getBranch() {
  //   this.reload.update(v => v + 1); // ✅ trigger โหลดใหม่
  // }

  // (ถ้าต้องการ item เดียว)


  searchLoading = signal(false);
  searchResults = signal<{ data: any[] }>({ data: [] });
  hasSearched = signal(false);

  search() {
    const branch = this.branchItem();
    if (!branch) return;

    const checkIn = moment(this.checkIn()).format('YYYY-MM-DD');
    const checkOut = moment(this.checkOut()).format('YYYY-MM-DD');
    const guests = this.totalGuestAmount();
    const rooms = this.totalRoomAmount();
    const url = `/api/Public/ReserveHotel/RoomSearch?BranchId=${branch.id}&checkIn=${checkIn}&checkOut=${checkOut}&guests=${guests}&rooms=${rooms}`;

    this.searchLoading.set(true);
    this.hasSearched.set(true);

    this.http.get<{ data: any[] }>(url).subscribe({
      next: (res) => {
        this.searchResults.set(res);
        this.searchLoading.set(false);
      },
      error: () => {
        this.searchResults.set({ data: [] });
        this.searchLoading.set(false);
      }
    });
  }

  action = signal<'guest' | 'date' | ''>('');
  toAction(v: 'guest' | 'date' | '') {
    this.action.set(v);
  }


  checkIn = signal<Date>(new Date());
  checkOut = signal<Date>(new Date(new Date().setDate(new Date().getDate() + 1)));
  updateDate(e: any) {
    if (e.status === 'update') {
      const oldIn = moment(this.checkIn()).format('YYYY-MM-DD');
      const oldOut = moment(this.checkOut()).format('YYYY-MM-DD');
      const dateChanged = oldIn !== e.inDate || oldOut !== e.outDate;

      this.checkIn.set(e.inDate)
      this.checkOut.set(e.outDate)
      this.action.set('');

      // เปลี่ยนวันเข้าพักใหม่ → ล้างห้องที่เลือกไว้ทั้งหมด ให้เลือกใหม่
      if (dateChanged) this.clearSelectedPlans();

      this.search();
    } else {
      this.action.set('');
    }
  }

  // ล้างห้อง/แพ็กเกจที่เลือกไว้ทั้งหมด
  clearSelectedPlans() {
    this.planQtyMap.set({});
    this.planPriceMap.set({});
    this.snapshotAdults.set(null);
    this.snapshotChildren.set(null);
  }


  totalAdultsAmount = signal<number>(2);
  totalChildrenAmount = signal<number>(0);
  totalGuestAmount = signal<number>(2);
  totalRoomAmount = signal<number>(1);
  updateGuest(e: any) {
    if (e.status === 'update') {
      // ถ้าเปลี่ยนจำนวนผู้เข้าพัก/ห้อง ให้ล้างห้องที่เคยเลือกไว้ (ผลค้นหาเปลี่ยน + snapshot ผู้พักเก่าจะผิด)
      const guestChanged = this.totalAdultsAmount() !== e.totalAdultsAmount
        || this.totalChildrenAmount() !== e.totalChildrenAmount
        || this.totalRoomAmount() !== e.totalRoomAmount;
      if (guestChanged) this.clearSelectedPlans();
      this.totalAdultsAmount.set(e.totalAdultsAmount)
      this.totalChildrenAmount.set(e.totalChildrenAmount)
      this.totalGuestAmount.set(e.totalGuestAmount)
      this.totalRoomAmount.set(e.totalRoomAmount)
      this.action.set('');
      this.search();
    } else {
      this.action.set('');
    }
  }

  guestModel = computed(() => ({
    totalAdultsAmount: this.totalAdultsAmount(),
    totalChildrenAmount: this.totalChildrenAmount(),
    totalGuestAmount: this.totalGuestAmount(),
    totalRoomAmount: this.totalRoomAmount(),
  }));


  ngOnDestroy(): void {
    if (this.st.ok) {
      window.removeEventListener('scroll', this.scrollHandler);
      window.removeEventListener('beforeunload', this.beforeUnloadHandler);
    }
  }

  private saveState() {
    this.st.setSession('listRoomState', JSON.stringify({
      branchId: this.branchItem()?.id ?? null,
      checkIn: moment(this.checkIn()).format('YYYY-MM-DD'),
      checkOut: moment(this.checkOut()).format('YYYY-MM-DD'),
      totalAdultsAmount: this.totalAdultsAmount(),
      totalChildrenAmount: this.totalChildrenAmount(),
      totalGuestAmount: this.totalGuestAmount(),
      totalRoomAmount: this.totalRoomAmount(),
      planQtyMap: this.planQtyMap(),
      planPriceMap: this.planPriceMap(),
      snapshotAdults: this.snapshotAdults(),
      snapshotChildren: this.snapshotChildren(),
    }));
  }

  toLocation() {
    this.saveState();
    const appId = this.ac.snapshot.params['app-id'];
    const branchId = this.ac.snapshot.params['branch-id'];
    const segments: any[] = ['/', AppUrl.list_location, appId];
    if (branchId) segments.push(branchId);
    this.router.navigate(segments);
  }

  toProfile() {
    this.router.navigate(['/', AppUrl.profile, this.ac.snapshot.params['app-id']],this.ac.snapshot.params['branch-id']);
  }

  getSelectedRoomsDetail() {
    const qtyMap = this.planQtyMap();
    const priceMap = this.planPriceMap();
    const nights = this.totalNights();
    const result: any[] = [];
    for (const room of this.searchResults().data) {
      for (const plan of (room.pricing ?? [])) {
        const key = `${room.id}_${plan.pricingModel}`;
        const qty = qtyMap[key] ?? 0;
        if (qty > 0) {
          const price = priceMap[key] ?? plan.price;
          result.push({ roomTypeId: room.id, roomName: room.name, planName: plan.pricingModel, price, qty, subtotal: price * qty * nights, maxCapacity: room.maxCapacity ?? 0 });
        }
      }
    }
    return result;
  }

  toNextStep() {
    this.saveState();

    const bookingData = {
      branchId: this.branchItem()?.id ?? '',
      branchName: this.branchDetailData()?.name ?? this.branchItem()?.name ?? '',
      branchAddress: this.branchAddress(),
      checkIn: moment(this.checkIn()).format('YYYY-MM-DD'),
      checkOut: moment(this.checkOut()).format('YYYY-MM-DD'),
      // ใช้จำนวนผู้พักปัจจุบันเสมอ (เปลี่ยนจำนวนผู้พักจะล้างห้องที่เลือกไว้แล้ว) — snapshot เก่าใน session อาจค้างค่าผิด
      totalAdults: this.totalAdultsAmount(),
      totalChildren: this.totalChildrenAmount(),
      totalNights: this.totalNights(),
      totalRooms: this.totalSelectedRooms(),
      totalPrice: this.totalSelectedPrice(),
      selectedRooms: this.getSelectedRoomsDetail(),
    };
    this.st.setSession('bookingData', JSON.stringify(bookingData));

    if (!this.hasToken()) {
      this.router.navigate(['/', AppUrl.signin, this.ac.snapshot.params['app-id']]);
      return;
    }
    this.router.navigate(['/', AppUrl.customer_info, this.ac.snapshot.params['app-id']]);
  }

  totalNights = computed(() => {
    const nights = moment(this.checkOut()).diff(moment(this.checkIn()), 'days');
    return Math.max(1, nights);
  });

  totalSelectedRooms = computed(() =>
    Object.values(this.planQtyMap()).reduce((sum, qty) => sum + qty, 0)
  );

  // รวม capacity ของห้องที่เลือก (qty * maxCapacity)
  totalSelectedCapacity = computed(() => {
    let total = 0;
    for (const room of this.searchResults().data) {
      if (!room.maxCapacity) continue;
      total += this.getRoomTotalQty(room.id) * room.maxCapacity;
    }
    return total;
  });

  // ตรวจสอบว่าเลือกห้องพอรองรับผู้พักทั้งหมดหรือยัง
  guestCapacityMet = computed(() => {
    const required = this.totalAdultsAmount() + this.totalChildrenAmount();
    if (required <= 0) return true;
    const hasCapacityRooms = this.searchResults().data.some((r: any) => r.maxCapacity > 0);
    if (!hasCapacityRooms) return true; // ห้องไม่มีข้อจำกัด capacity ไม่ต้องตรวจ
    return this.totalSelectedCapacity() >= required;
  });

  totalSelectedPrice = computed(() => {
    const qtyMap = this.planQtyMap();
    const priceMap = this.planPriceMap();
    const nights = this.totalNights();
    let total = 0;
    for (const [key, qty] of Object.entries(qtyMap)) {
      if (qty > 0) {
        total += (priceMap[key] ?? 0) * qty * nights;
      }
    }
    return total;
  });

  // ---- Plan quantity & price (snapshot ราคา/ผู้พักตอนเลือก) ----
  planQtyMap = signal<Record<string, number>>({});
  planPriceMap = signal<Record<string, number>>({});
  snapshotAdults = signal<number | null>(null);
  snapshotChildren = signal<number | null>(null);

  getPlanQty(roomId: string, planId: string): number {
    return this.planQtyMap()[`${roomId}_${planId}`] ?? 0;
  }

  selectPlan(roomId: string, planId: string, price: number) {
    const key = `${roomId}_${planId}`;
    // snapshot ผู้พักตอนเลือกห้องครั้งแรก
    if (Object.keys(this.planQtyMap()).length === 0) {
      this.snapshotAdults.set(this.totalAdultsAmount());
      this.snapshotChildren.set(this.totalChildrenAmount());
    }
    this.planQtyMap.update(m => ({ ...m, [key]: 1 }));
    this.planPriceMap.update(m => ({ ...m, [key]: price }));
  }

  setPlanQty(roomId: string, planId: string, qty: number) {
    this.planQtyMap.update(m => ({ ...m, [`${roomId}_${planId}`]: qty }));
  }

  removePlan(roomId: string, planId: string) {
    const key = `${roomId}_${planId}`;
    this.planQtyMap.update(m => { const n = { ...m }; delete n[key]; return n; });
    this.planPriceMap.update(m => { const n = { ...m }; delete n[key]; return n; });
    // clear snapshot เมื่อไม่มีห้องเหลือ
    if (Object.keys(this.planQtyMap()).length === 0) {
      this.snapshotAdults.set(null);
      this.snapshotChildren.set(null);
    }
  }

  // ---- Amenities expand/collapse ----
  expandedRooms = signal<Set<string>>(new Set());

  isExpanded(roomId: string): boolean {
    return this.expandedRooms().has(roomId);
  }

  toggleAmenities(roomId: string) {
    this.expandedRooms.update(set => {
      const next = new Set(set);
      next.has(roomId) ? next.delete(roomId) : next.add(roomId);
      return next;
    });
  }

  getAmenities(room: any): any[] {
    return room.amenities ?? [];
  }

  getDisplayedAmenities(room: any): any[] {
    const all = this.getAmenities(room);
    return this.isExpanded(room.id) ? all : all.slice(0, 6);
  }

  getPricePlans(room: any): any[] {
    return room.pricing ?? [];
  }

  // ราคาแสดงผลต่อคืน: ถ้ามี dailyPrices หลายวันให้ใช้ค่าเฉลี่ยต่อคืน, ไม่งั้นใช้ plan.price
  getPlanPrice(plan: any): number {
    const dp = plan?.dailyPrices;
    if (Array.isArray(dp) && dp.length > 0) {
      const sum = dp.reduce((s: number, d: any) => s + (Number(d?.price) || 0), 0);
      return Math.round(sum / dp.length);
    }
    return Number(plan?.price) || 0;
  }

  // availableRooms อยู่ที่ room level — ใช้ร่วมกันทุก plan
  getRoomMaxAvailable(room: any): number {
    return Number(room.availableRooms ?? 0);
  }

  // ยอดรวมห้องที่เลือกไปแล้วทุก plan ของ room นี้
  getRoomTotalQty(roomId: string): number {
    const map = this.planQtyMap();
    return Object.entries(map)
      .filter(([k]) => k.startsWith(`${roomId}_`))
      .reduce((sum, [, qty]) => sum + qty, 0);
  }

  // ตัวเลือกจำนวนห้อง: [1 .. remaining] โดย remaining = availableRooms − (totalSelected − currentPlanQty)
  getRoomOptions(room: any, plan: any): number[] {
    const maxForRoom = this.getRoomMaxAvailable(room);
    const totalSelected = this.getRoomTotalQty(room.id);
    const currentPlanQty = this.getPlanQty(room.id, plan.pricingModel);
    const remaining = maxForRoom - totalSelected + currentPlanQty;
    const max = Math.max(0, remaining);
    return max > 0 ? Array.from({ length: max }, (_, i) => i + 1) : [];
  }

  // ---- Gallery ----
  galleryOpen = signal(false);
  galleryImages = signal<any[]>([]);
  galleryIndex = signal(0);

  openGallery(images: any[], index: number) {
    this.galleryImages.set(images);
    this.galleryIndex.set(index);
    this.galleryOpen.set(true);
  }

  closeGallery() { this.galleryOpen.set(false); }

  prevImage() {
    this.galleryIndex.update(i => (i - 1 + this.galleryImages().length) % this.galleryImages().length);
  }

  nextImage() {
    this.galleryIndex.update(i => (i + 1) % this.galleryImages().length);
  }
}
